export default __webpack_public_path__ + "static/media/instagramHover.989449e7.svg";